<template>
  <div class="useful-information">
    <div class="useful-information-header">
      <h2 class="useful-information-header__title">
        {{ messages.title }}
      </h2>
      <a
        :href="link.link"
        class="useful-information-header__link"
      >
        {{ link.title }}
      </a>
    </div>
    <div
      v-if="screenWidth >= 768"
      class="useful-information-items"
    >
      <UsefulInformationCard v-for="item in items" :key="item.url" :result="item"/>
    </div>
    <Swiper
      v-else
      v-bind="settings"
    >
      <SwiperSlide v-for="item in items" :key="item.url">
        <UsefulInformationCard :result="item"/>
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'swiper/vue';
import {Pagination} from "swiper";

export default {
  name: 'UsefulInformation',
  props: ['result'],
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      settings: {
        modules: [Pagination],
        pagination: {
          clickable: true
        },
        spaceBetween: 20,
        slidesPerView: 1.19,
      },
    }
  },
  computed: {
    messages() {
      return this.result.messages;
    },
    link() {
      return this.result.header_right;
    },
    items() {
      return this.result.items;
    },
  }
}
</script>

<style lang="scss" scoped>
.useful-information {
  @include mobile {
    margin-right: -15px;
    padding-left: 13px;
  }

  :deep {
    .swiper-pagination {
      position: static;
      margin-top: 20px;
    }

    .swiper-pagination-bullet {
      background-color: #E9EBED;
      opacity: 1;
    }

    .swiper-pagination-bullet-active {
      background-color: #D8DCDE;
    }
  }
}

.useful-information-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 0 0 29px;
  @include mobile {
    margin: 0 0 17px;
  }

  &__title {
    margin: 0;
  }

  &__link {
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    color: #00A59E;
  }
}

.useful-information-items {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 31px;
}
</style>